<template>
    <div>
        <h2
            v-if="appParams && appParams.staticTranslations"
            class="text-center itb-horizontal-border pt-5"
            id="itb-h2-inspirations"
            ref="realizations"
        >
            {{
                inspirationTitle +
                " " +
                appParams.staticTranslations["title.inspirations"]
            }}
        </h2>
        <section
            class="itb-references-alike-set itb-other-products-realizations"
            style="margin-top: 3.7rem"
        >
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-12">
                        <div class="row">
                            <div
                                class="col-12 col-md-4"
                                v-for="(realization, index) in realizations"
                            >
                                <div
                                    class="card w-100 itb-margin-bottom itb-lazy-loading-bg"
                                    role="button"
                                    @click="
                                        viewRealization(
                                            realization.id,
                                            realization.alias
                                        )
                                    "
                                    v-lazy:background-image="
                                        realization.image
                                            ? '/uploads/' + realization.image
                                            : null
                                    "
                                >
                                    <div class="card-body d-flex p-0">
                                        <div
                                            class="itb-text align-self-end w-100"
                                        >
                                            <h3 class="mb-0">
                                                {{ realization.name }}
                                            </h3>
                                            <p class="itb-h3-subtitle">
                                                {{ realization.location }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "OtherProductsRealizations",
    props: {
        realizations: Array,
        categoryAlias: String,
        inspirationTitle: String,
    },
    computed: {
        ...mapGetters({
            appParams: "getAppParams",
        }),
    },
    methods: {
        viewRealization(id, alias) {
            this.$router.push(
                "/other-products-realizations/" +
                    this.categoryAlias +
                    "/" +
                    id +
                    "-" +
                    alias
            );
        },
    },
};
</script>
